import SentInvitationItem from './SentInvitationItem';

export default SentInvitationItem;
